<div class="border rounded bg-white p-4 text-sm">
    <h6 class="font-medium text-gray-600" *ngIf="title">{{ title }}</h6>
    <ul class="">
        <li *ngIf="emailAddress">{{ emailAddress }}</li>
        <li>{{ address?.fullName }}</li>
        <li>{{ address?.streetLine1 }}</li>
        <li *ngIf="address?.streetLine2">{{ address?.streetLine2 }}</li>
        <li>{{ address?.city }}, {{ address?.province }}</li>
        <li>{{ address?.postalCode }}</li>
        <li>{{ getCountryName() }}</li>
        <li>{{ address?.phoneNumber }}</li>
    </ul>
    <ng-content></ng-content>
</div>
